const URL_FACTORY = {
    GET_URL_EstadisticasGlobales: (temporada, jornadaActiva) => {
        const url = `${process.env.NEXT_PUBLIC_URL_FUNCTION
            }lfmPlayers/playersStats?temporada=${temporada}&jornadaActiva=${jornadaActiva ?? -1}`;
        return url;
    },
    GetTeamImageLogo: (teamSlug, customWidth) => {
        const width = customWidth ?? 51;
        if (teamSlug) {
            return `${process.env.NEXT_PUBLIC_IMAGES}/teams/${teamSlug}.png${width ? `?width=${width}` : ''}`;
        }

        return `${process.env.NEXT_PUBLIC_IMAGES}/teams/unknown-teams.png${width ? `?width=${width}` : ''}`;
    },
    GetTeamImage: (teamSlug) => {
        const width = 51;
        if (teamSlug) {
            return `${process.env.NEXT_PUBLIC_IMAGES}/teams/${teamSlug}.png${width ? `?width=${width}` : ''}`;
        }

        return `${process.env.NEXT_PUBLIC_IMAGES}/teams/unknown-teams.png${width ? `?width=${width}` : ''}`;
    },
    GetPlayerTemplateImage: () => `${process.env.NEXT_PUBLIC_IMAGES}/jugadores/0.png`,
    GetCountryImage: (countryCode, width) =>
        `${process.env.NEXT_PUBLIC_IMAGES}/countries/${countryCode}.png?width=${width ?? 15}`,
    GetUniquePlayerImage: (image, width, playerId) => {
        if (!image && playerId) {
            return `${process.env.NEXT_PUBLIC_IMAGES}/jugadores/${playerId}.png`;
        }
        if (image.includes('-')) {
            return image;
        }

        const url = `${image}${width ? `?width=${width}` : ''}`;
        return url;
    },

    // Analisis Partido
    GetAnalisisPartido: `${process.env.NEXT_PUBLIC_API}/analisis-partido`,

    // Previa Partido (nuevo endpoint para previas públicas)
    GetPreviaPartido: `${process.env.NEXT_PUBLIC_API}/previa-partido`,

    // Previa La Liga Fantasy (endpoint antiguo)
    GetPreviaLaLigaFantasy: `${process.env.NEXT_PUBLIC_API}/alineaciones/previa`,

    // Accounts
    ConfirmEmail: (token) => `${process.env.NEXT_PUBLIC_API}/accounts/confirm-email/${token}`,
    DeleteAccount: `${process.env.NEXT_PUBLIC_API}/accounts/delete-account`,
    ForgotPassword: (username) => `${process.env.NEXT_PUBLIC_API}/accounts/forgot-password/${username}`,
    ResetPassword: `${process.env.NEXT_PUBLIC_API}/accounts/reset-password`,
    ResendEmailConfirmation: `${process.env.NEXT_PUBLIC_API}/accounts/verify-email`,
    RegisterUserUrl: `${process.env.NEXT_PUBLIC_API}/accounts/register`,
    LoginUserUrl: `${process.env.NEXT_PUBLIC_API}/accounts/login`,
    GoogleLoginUrl: `${process.env.NEXT_PUBLIC_API}/accounts/google-login`,

    // Chat
    ChatStartUrl: `${process.env.NEXT_PUBLIC_API}/chat/start`,
    ChatMessageUrl: `${process.env.NEXT_PUBLIC_API}/chat/message`,
    ChatConversationUrl: (chatId) => `${process.env.NEXT_PUBLIC_API}/chat/conversation/${chatId}`,
    ChatAnalyzeIntentUrl: `${process.env.NEXT_PUBLIC_API}/chat/analyze-intent`,

    UpdatePassword: `${process.env.NEXT_PUBLIC_API}/accounts/update-user-password`,
    UserProfile: `${process.env.NEXT_PUBLIC_API}/accounts/user-profile`,
    UpsertAccount: `${process.env.NEXT_PUBLIC_API}/accounts/upsert-account`,
    GetAccounts: `${process.env.NEXT_PUBLIC_API}/accounts/accounts`,
    UploadAccountImage: `${process.env.NEXT_PUBLIC_API}/images/upload-account-image`,
    UploadPostImage: `${process.env.NEXT_PUBLIC_API}/images/uploads/posts`,
    SetUserTrial: `${process.env.NEXT_PUBLIC_API}/accounts/trial`,

    // Biwenger
    GetBiwengerEstadisticas: `${process.env.NEXT_PUBLIC_API}/biwenger/estadisticas`,
    GetBiwengerPlayers: `${process.env.NEXT_PUBLIC_API}/biwenger/players`,

    // Calendario Admin
    GetFantasyAdminCalendar: `${process.env.NEXT_PUBLIC_API}/calendario/admin`,
    SaveAdminCalendar: `${process.env.NEXT_PUBLIC_API}/calendario/admin/save`,
    ObtenerCalendarioFantasy: `${process.env.NEXT_PUBLIC_API}/calendario/fantasy`,

    // Chollos
    ChollosFantasy: `${process.env.NEXT_PUBLIC_API}/chollos-fantasy`,

    // Home Page
    GetHomePage: `${process.env.NEXT_PUBLIC_API}/home`,

    // Fantasy Players
    GET_URL_FANTASY_MARKET_VALUES: `${process.env.NEXT_PUBLIC_API}/fantasy-players/mercado`,
    GetFantasyPlayer: `${process.env.NEXT_PUBLIC_API}/fantasy-players/fantasy-player`,
    GET_URL_FANTASY_LAST_MARKET_VALUES: (id) =>
        `${process.env.NEXT_PUBLIC_API}/fantasy-players/market-values/${id}`,
    GET_URL_FantasyPlayers: `${process.env.NEXT_PUBLIC_API}/fantasy-players`,
    GetHistoricFantasy: `${process.env.NEXT_PUBLIC_API}/fantasy-players/historic`,
    MejoresRachas: `${process.env.NEXT_PUBLIC_API}/fantasy-players/mejores-rachas`,
    GetFantasyPoints: `${process.env.NEXT_PUBLIC_API}/fantasy-points`,
    GetRachas: `${process.env.NEXT_PUBLIC_API}/rachas`,

    // Configurations
    GetConfiguration: `${process.env.NEXT_PUBLIC_API}/configuration`,
    SaveConfiguration: `${process.env.NEXT_PUBLIC_API}/configuration`,

    // Votes
    GetVotes: `${process.env.NEXT_PUBLIC_API}/votes`,
    AddVote: `${process.env.NEXT_PUBLIC_API}/votes/add`,

    // Convocatorias
    GetConvocatorias: `${process.env.NEXT_PUBLIC_API}/convocatoria`,
    UpdateConvocatorias: `${process.env.NEXT_PUBLIC_API}/convocatoria/update`,
    PublishConvocatorias: `${process.env.NEXT_PUBLIC_API}/convocatoria/publish`,
    GetPublishedConvocatoria: `${process.env.NEXT_PUBLIC_API}/convocatoria/published`,

    // Fantasy Analysis
    URL_ExecuteAnalysis: `${process.env.NEXT_PUBLIC_API}/fantasy-analysis/v2`,

    // Fantasy Squad
    CreateFantasySquad: `${process.env.NEXT_PUBLIC_API}/fantasy-squad/create`,
    UpdateFantasySquad: (isShared = false) =>
        `${process.env.NEXT_PUBLIC_API}/fantasy-squad/update${isShared ? '?isShared=true' : ''}`,
    DeleteFantasySquad: (id, isShared = false) =>
        `${process.env.NEXT_PUBLIC_API}/fantasy-squad/${id}${isShared ? '?isShared=true' : ''}`,
    GET_URL_FANTASY_SQUAD: (id) => `${process.env.NEXT_PUBLIC_API}/fantasy-squad/${id}`,
    GetFantasySquads: `${process.env.NEXT_PUBLIC_API}/fantasy-squads`,
    GetFantasySquadsV2: `${process.env.NEXT_PUBLIC_API}/fantasy-squads/v2`,
    GetJugadoresPlantillas: (season) =>
        `${process.env.NEXT_PUBLIC_API}/fantasy-squads/jugadores-plantillas${season ? `?season=${season}` : ''}`,
    GetPlayerMarketEvolution: `${process.env.NEXT_PUBLIC_API}/fantasy-players/market-evolution`,
    GetSharedFantasySquad: (code) => `${process.env.NEXT_PUBLIC_API}/fantasy-squad/shared/${code}`,
    ShareFantasySquads: `${process.env.NEXT_PUBLIC_API}/fantasy-squad/share`,
    UpsertFantasySquad: `${process.env.NEXT_PUBLIC_API}/fantasy-squad/upsert`,
    GetPublicPlantillas: `${process.env.NEXT_PUBLIC_API}/fantasy-squad/public-plantillas`,

    // Fantasy Stats
    GetEstadisticasFantasy: `${process.env.NEXT_PUBLIC_API}/fantasy-stats/get-fantasy-estadisticas`,
    GET_URL_GetFantasyPlayersStats: `${process.env.NEXT_PUBLIC_API}/fantasy-stats/get-fantasy-stats`,
    ObtenerPuntuacionesJornada: `${process.env.NEXT_PUBLIC_API}/puntos-fantasy`,

    // Fixture Lineups
    GET_URL_ManagerLineups: `${process.env.NEXT_PUBLIC_API}/manager-lineups`,
    UpdateAlineacionesConfirmadas: `${process.env.NEXT_PUBLIC_API}/alineaciones-confirmadas/update`,

    // Fixture Section
    GetFixtureBox: (fixtureId) => `${process.env.NEXT_PUBLIC_API}/fixture-box/${fixtureId}`,
    GetFixtureFantasyStats: (fixtureId) =>
        `${process.env.NEXT_PUBLIC_API}/fixture-fantasy-stats/${fixtureId}`,
    GetFixturePrediction: (fixtureId) => `${process.env.NEXT_PUBLIC_API}/fixture-predictions/${fixtureId}`,
    GetFixtureFantasyAllStats: (fixtureId) =>
        `${process.env.NEXT_PUBLIC_API}/fixture-fantasy-stats/all-stats/${fixtureId}`,
    GetFixtureFantasyLiveStats: (fixtureId) =>
        `${process.env.NEXT_PUBLIC_API}/fixture-fantasy-stats/live/${fixtureId}`,

    // Fixtures
    POST_URL_TeamCalendar: `${process.env.NEXT_PUBLIC_API}/fixtures/team`,
    GetFixturesAlineacionesProbables: `${process.env.NEXT_PUBLIC_API}/next-admin-lineups`,
    GetFixturesAlineacionesProbablesV2: `${process.env.NEXT_PUBLIC_API}/next-admin-lineups/v2`,
    GetSeoFixture: (fixtureId) => `${process.env.NEXT_PUBLIC_API}/seo-fixture/${fixtureId}`,
    GET_URL_RecentFixtures: `${process.env.NEXT_PUBLIC_API}/fixtures/recent`,
    UploadImage: (playerId) => `${process.env.NEXT_PUBLIC_API}/images/upload-image/${playerId}`,
    GetLanzadoresDePenaltis: `${process.env.NEXT_PUBLIC_API}/lanzadores-penaltis`,
    GetFixtures: `${process.env.NEXT_PUBLIC_API}/fixtures`,
    GetFixturesV2: `${process.env.NEXT_PUBLIC_API}/fixtures/v2`,
    GetFixturesV3: `${process.env.NEXT_PUBLIC_API}/fixtures/v3`,
    GetAllFixtures: `${process.env.NEXT_PUBLIC_API}/fixtures/getall`,
    GetRounds: `${process.env.NEXT_PUBLIC_API}/fixture-rounds`,
    UpdateFixtureRounds: `${process.env.NEXT_PUBLIC_API}/fixture-rounds/update`,
    GetFixtureEvents: (fixtureId) => `${process.env.NEXT_PUBLIC_API}/fixture-events/${fixtureId}`,
    UpdateFixtureEvents: `${process.env.NEXT_PUBLIC_API}/fixture-events`,
    GetPartidosForHome: `${process.env.NEXT_PUBLIC_API}/partidos`,

    // Lineups
    GetAdminLineups: `${process.env.NEXT_PUBLIC_API}/lineups/admin`,
    SaveAdminLineups: `${process.env.NEXT_PUBLIC_API}/lineups/admin/update`,
    GetEditorLineups: `${process.env.NEXT_PUBLIC_API}/lineups/editor`,
    SaveEditorLineups: `${process.env.NEXT_PUBLIC_API}/lineups/editor/update`,
    GetAdminLineupForEditor: `${process.env.NEXT_PUBLIC_API}/lineups/editor/from-admin`,
    GET_URL_AlineacionesProbables_Initial: `${process.env.NEXT_PUBLIC_API}/lineups/initial`,
    GET_URL_UpdateLineup: `${process.env.NEXT_PUBLIC_API}/lineups/update`,
    GetFullLineups: `${process.env.NEXT_PUBLIC_API}/lineups`,
    ObtenerAlineacionesProbables: (fixtureId) =>
        `${process.env.NEXT_PUBLIC_API}/alineaciones/partido/${fixtureId}`,
    ObtenerAlineacionesProbablesEquipo: (teamId) =>
        `${process.env.NEXT_PUBLIC_API}/alineaciones/equipo/${teamId}`,
    GetEstadisticasPartido: `${process.env.NEXT_PUBLIC_API}/alineaciones/estadisticas`,
    GetEstadisticasFantasyEnVivo: (fixtureId) =>
        `${process.env.NEXT_PUBLIC_API}/alineaciones/estadisticas-fantasy-en-vivo/${fixtureId}`,
    GetUpcomingFixturesSitemap: `${process.env.NEXT_PUBLIC_API}/fixtures/sitemap/upcoming`,

    // Top Star
    GetTopStar: (slug) => `${process.env.NEXT_PUBLIC_API}/top-star${slug ? `?slug=${slug}` : ''}`,
    GetEstadisticasFantasyMarca: `${process.env.NEXT_PUBLIC_API}/fantasy-stats/get-estadisticas-fantasy-marca`,
    GetEstadisticasMisterFantasy: `${process.env.NEXT_PUBLIC_API}/fantasy-stats/get-estadisticas-mister-fantasy`,
    GetEditorTopStars: `${process.env.NEXT_PUBLIC_API}/top-star/editor`,
    UpsertTopStar: `${process.env.NEXT_PUBLIC_API}/top-star`,
    DeleteTopStar: (slug) => `${process.env.NEXT_PUBLIC_API}/top-star/${slug}`,
    GetNextRoundWithFixtures: `${process.env.NEXT_PUBLIC_API}/top-star/next-round`,

    // Noticias Flash
    GetNoticiasFlash: `${process.env.NEXT_PUBLIC_API}/noticias-flash`,
    GetNoticiasFlashAdmin: `${process.env.NEXT_PUBLIC_API}/noticias-flash-admin`,
    DeleteNoticiasFlashAdmin: (id) => `${process.env.NEXT_PUBLIC_API}/noticia-flash/${id}`,
    EditNoticiasFlashAdmin: `${process.env.NEXT_PUBLIC_API}/noticia-flash/update`,

    // Stories
    GetAllStories: `${process.env.NEXT_PUBLIC_API}/stories/all`,
    GetStoryById: (id) => `${process.env.NEXT_PUBLIC_API}/stories/${id}`,
    CreateStory: `${process.env.NEXT_PUBLIC_API}/stories`,
    DeleteStory: (id) => `${process.env.NEXT_PUBLIC_API}/stories/${id}`,
    UpdateStory: (id) => `${process.env.NEXT_PUBLIC_API}/stories/${id}`,

    // Once tipo
    GetOnceTipo: `${process.env.NEXT_PUBLIC_API}/once-tipo-admin`,
    SaveOnceTipo: `${process.env.NEXT_PUBLIC_API}/upsert-once-tipo-admin`,
    GetOnceTipoUser: (teamId) => `${process.env.NEXT_PUBLIC_API}/once-tipo/${teamId}`,

    // Oraculo Fantasy
    GetOraculoFantasy: `${process.env.NEXT_PUBLIC_API}/oraculo-fantasy`,

    // Players
    URL_AnalisisPlantillaV2: `${process.env.NEXT_PUBLIC_API}/players`,
    GetAllPlayers: `${process.env.NEXT_PUBLIC_API}/players/all`,
    GetAllPlayersFilter: `${process.env.NEXT_PUBLIC_API}/players/filter`,
    GetPlayersByStatus: `${process.env.NEXT_PUBLIC_API}/players/status`,
    GetPlayersForImage: `${process.env.NEXT_PUBLIC_API}/players/v2`,
    SearchPlayer: `${process.env.NEXT_PUBLIC_API}/players/search`,
    SyncPlayerImages: (id) => `${process.env.NEXT_PUBLIC_API}/players/sync-images/${id}`,
    GET_URL_ChangePlayerStatus: `${process.env.NEXT_PUBLIC_API}/players/upsert`,
    UpdateParteMedico: (playerId) => `${process.env.NEXT_PUBLIC_API}/players/update-parte-medico/${playerId}`,
    UpdateParteMedico: (playerId) => `${process.env.NEXT_PUBLIC_API}/players/update-parte-medico/${playerId}`,
    UpsertAdminFantasyPlayers: `${process.env.NEXT_PUBLIC_API}/fantasy-players/admin`,
    UpsertAdminFantasyPlayersOnlyPlayers: `${process.env.NEXT_PUBLIC_API}/fantasy-players/only-players`,
    GetFechasClausulables: `${process.env.NEXT_PUBLIC_API}/players/clausulables`,
    GetPlayerProjection: (id) => `${process.env.NEXT_PUBLIC_API}/players/projection/${id}`,
    GetPlayerCalendar: `${process.env.NEXT_PUBLIC_API}/calendario/partidos`,
    GetPlayerMinutes: `${process.env.NEXT_PUBLIC_API}/players/minutes`,
    GetPlayerInformation: `${process.env.NEXT_PUBLIC_API}/player-information`,
    SearchPlayerByText: (search) => `${process.env.NEXT_PUBLIC_API}/search-player/${search}`,
    ResetConvocatorias: `${process.env.NEXT_PUBLIC_API}/players/reset-convocatoria-seleccion`,
    GetActivePlayers: `${process.env.NEXT_PUBLIC_API}/players/active`,

    // Players Profile
    GetPlayersProfile: `${process.env.NEXT_PUBLIC_API}/players-profile`,
    GetPlayerProfile: `${process.env.NEXT_PUBLIC_API}/players/profile`,

    // Predicting manager
    GET_URL_Predicting_Manager_Ranking: `${process.env.NEXT_PUBLIC_API}/predicting-scores/ranking`,

    // Puja Fantasy
    PujaFantasy: `${process.env.NEXT_PUBLIC_API}/puja-fantasy`,
    GetStanding: `${process.env.NEXT_PUBLIC_API}/standing`,

    // Stripe
    CreateCheckoutSession: `${process.env.NEXT_PUBLIC_API}/stripe/create-checkout-session`,
    CancelSubscription: `${process.env.NEXT_PUBLIC_API}/stripe/cancel-suscription`,
    ReactivateSubscription: `${process.env.NEXT_PUBLIC_API}/stripe/reactivate-subscription`,
    GetPayment: (paymentId) => `${process.env.NEXT_PUBLIC_API}/stripe/payment/${paymentId}`,

    // Titularidades
    ObtenerTitularidades: `${process.env.NEXT_PUBLIC_API}/titularidades`,

    // Tierlists
    PublicTierlists: `${process.env.NEXT_PUBLIC_API}/tierlists/public`,
    PublicTierlistsCreadorDeContenido: `${process.env.NEXT_PUBLIC_API}/tierlists/author`,
    ListTierlists: `${process.env.NEXT_PUBLIC_API}/tierlist/list`,
    ViewTierlist: (slug) => `${process.env.NEXT_PUBLIC_API}/tierlist/ver-tierlist/${slug}`,
    ViewTierlistById: (id) => `${process.env.NEXT_PUBLIC_API}/tierlist/ver-tierlist-id/${id}`,
    GetTierlist: (slug) => `${process.env.NEXT_PUBLIC_API}/tierlist/${slug}`,
    CreateTierlist: `${process.env.NEXT_PUBLIC_API}/tierlist`,
    DeleteTierlist: (id) => `${process.env.NEXT_PUBLIC_API}/tierlist/${id}`,
    DuplicateTierlist: `${process.env.NEXT_PUBLIC_API}/tierlist/duplicate`,

    // Recomendaciones
    CreateRecomendacion: `${process.env.NEXT_PUBLIC_API}/recomendaciones`,
    UpdateRecomendacion: (id) => `${process.env.NEXT_PUBLIC_API}/recomendaciones/${id}`,
    DeleteRecomendacion: (id) => `${process.env.NEXT_PUBLIC_API}/recomendaciones/${id}`,
    GetRecomendacionById: (id) => `${process.env.NEXT_PUBLIC_API}/recomendaciones/${id}`,
    GetMyRecomendaciones: `${process.env.NEXT_PUBLIC_API}/recomendaciones/my`,
    GetRecomendacionBySlug: (slug) => `${process.env.NEXT_PUBLIC_API}/recomendaciones/public/${slug}`,
    GetPublicRecomendaciones: `${process.env.NEXT_PUBLIC_API}/recomendaciones/public`,
    ObtenerRecomendacionesEquipo: `${process.env.NEXT_PUBLIC_API}/recomendaciones/teams`,

    // Noticias
    GetActivities: `${process.env.NEXT_PUBLIC_API}/activities`,
    GetPublishedArticles: `${process.env.NEXT_PUBLIC_API}/noticias/noticias-publicadas`,
    URL_GET_RECENT_ARTICLES: `${process.env.NEXT_PUBLIC_API}/noticias/noticias-publicadas`,
    GetColaboradores: `${process.env.NEXT_PUBLIC_API}/colaboradores`,
    URL_Survey: `${process.env.NEXT_PUBLIC_API}/encuesta`,
    URL_CREAR_NOTICIAS: `${process.env.NEXT_PUBLIC_API}/noticias/crear-noticia`,
    ObtenerMasNoticias: `${process.env.NEXT_PUBLIC_API}/noticias/mas-noticias`,
    ObtenerNoticiasPorEquipo: (equipo) => {
        const baseUrl = `${process.env.NEXT_PUBLIC_API}/noticias/noticias-equipo/${equipo}`;
        return baseUrl;
    },

    // Virus FIFA
    GetVirusFifa: `${process.env.NEXT_PUBLIC_API}/virus-fifa/convocatoria`,
    UpdateVirusFifa: `${process.env.NEXT_PUBLIC_API}/virus-fifa/convocatoria`,

    // Contact
    Contact: `${process.env.NEXT_PUBLIC_API}/contact-us`,

    // Planificador Jornadas
    GetPlanificadorJornadas: `${process.env.NEXT_PUBLIC_API}/planificador-jornadas`,

    // Jornadas
    GetJornadasDisputadas: `${process.env.NEXT_PUBLIC_API}/jornadas/disputadas`,
    GetJornadasAlineacionesProbables: `${process.env.NEXT_PUBLIC_API}/jornadas/alineaciones-probables`,

    // Premium
    ObtenerDashboardPremium: `${process.env.NEXT_PUBLIC_API}/premium/dashboard`,
    ObtenerActividadesPremium: (type, skip, take) =>
        `${process.env.NEXT_PUBLIC_API}/premium/actividades/${type}?skip=${skip ?? 0}&take=${take ?? 10}`,
    ObtenerActividadPremium: (slug) => `${process.env.NEXT_PUBLIC_API}/premium/activity/${slug}`,

    // Push Notifications
    RegisterPushNotifications: `${process.env.NEXT_PUBLIC_API}/push-notifications/register`,
    SendPushNotification: `${process.env.NEXT_PUBLIC_API}/push-notifications/send-push`,

    // Saldo Arbitral
    ObtenerSaldoArbitral: `${process.env.NEXT_PUBLIC_API}/saldo-arbitral`,

    // Centro de información
    GetCentroDeInformacion: `${process.env.NEXT_PUBLIC_API}/scraper/results`,
    GetCentroDeInformacionFeed: `${process.env.NEXT_PUBLIC_API}/scraper/feed`,

    // Head to Head
    ObtenerHistoricoDePartidos: (fixtureId, amount = 10) =>
        `${process.env.NEXT_PUBLIC_API}/fixtures/h2h/${fixtureId}?amount=${amount}`,

    // User settings
    GetUserSettings: `${process.env.NEXT_PUBLIC_API}/user-settings`,

    // Guias Fantasy
    ObtenerGuiasFantasy: (fantasy) => `${process.env.NEXT_PUBLIC_API}/guia/${fantasy}`,

    // Obtener Prediccion del Tiempo
    ObtenerPrediccionDelTiempo: (fixtureId) =>
        `${process.env.NEXT_PUBLIC_API}/alineaciones/aemet/${fixtureId}`,

    // Partido Fixture Events
    ObtenerPartidoFixtureEvents: (id, extraId) => {
        const validId = id || extraId;
        if (!validId) return null;
        let url = `${process.env.NEXT_PUBLIC_API}/alineaciones/events/${validId}`;
        if (extraId && extraId !== validId) {
            url += `?extraId=${extraId}`;
        }
        return url;
    },

    // Partido Estadisticas
    ObtenerPartidoEstadisticas: `${process.env.NEXT_PUBLIC_API}/alineaciones/estadisticas`,
    ObtenerPartidoEstadisticasEquipo: (id) => `${process.env.NEXT_PUBLIC_API}/fixture-statistics/${id}`,

    // Partido Prediccion de Partido
    ObtenerPrediccionDePartido: (fixtureId) =>
        `${process.env.NEXT_PUBLIC_API}/alineaciones/prediccion/${fixtureId}`,

    // Sauron
    ActualizarNoticiaViews: (id) => `${process.env.NEXT_PUBLIC_URL_FANTASY_FUNCTION}/sauron/${id}`,
    GetNoticiasDestacadas: (amount) => `${process.env.NEXT_PUBLIC_API}/noticias/destacadas?amount=${amount}`,

    // Stats
    ObtenerStatsPartido: `${process.env.NEXT_PUBLIC_API}/alineaciones/standing`,
    ObtenerMinuteroFantasyData: `${process.env.NEXT_PUBLIC_API}/alineaciones/minutero`,
    ObtenerAlineacionesEditores: `${process.env.NEXT_PUBLIC_API}/alineaciones/editores`,

    // Fichajes
    ObtenerFichajes: `${process.env.NEXT_PUBLIC_API}/transfers/listado`,
    ObtenerEquiposFichajes: (search) => `${process.env.NEXT_PUBLIC_API}/transfers/search/${search}`,

    ObtenerEstadisticasPartido: `${process.env.NEXT_PUBLIC_API}/estadisticas/equipo`,
    ObtenerEquipoRelated: `${process.env.NEXT_PUBLIC_API}/equipo/related`,
    ObtenerEvolucionEquipo: `${process.env.NEXT_PUBLIC_API}/equipo/evolucion`,
    ObtenerEstadoPlantilla: `${process.env.NEXT_PUBLIC_API}/equipo/plantilla`,
    ObtenerProximosPartidos: `${process.env.NEXT_PUBLIC_API}/equipo/proximos-partidos`,
    ObtenerPrediccionDeMercado: `${process.env.NEXT_PUBLIC_API}/fantasy-players/prediccion-mercado`,

    // Ruleta
    ObtenerPreguntasRuleta: `${process.env.NEXT_PUBLIC_API}/ruleta/pregunta`,
    ValidarRespuestaRuleta: `${process.env.NEXT_PUBLIC_API}/ruleta/validar-respuesta`,
    ObtenerRankingRuleta: `${process.env.NEXT_PUBLIC_API}/ruleta/ranking`,

    // Favoritos
    AgregarFavorito: `${process.env.NEXT_PUBLIC_API}/favoritos/add`,
    EliminarFavorito: `${process.env.NEXT_PUBLIC_API}/favoritos/remove`,
    ObtenerFavoritos: `${process.env.NEXT_PUBLIC_API}/favoritos`,
    FavoritosNoticias: `${process.env.NEXT_PUBLIC_API}/favoritos/noticias`,
    FavoritosNoticiasFlash: `${process.env.NEXT_PUBLIC_API}/favoritos/noticias-flash`,
    FavoritosFantasyInfo: `${process.env.NEXT_PUBLIC_API}/favoritos/jugadores`,

    // Logs
    GetLogsPaginated: `${process.env.NEXT_PUBLIC_API}/logs/paginated`,

    // Predicciones Fantasy
    ObtenerJornadaPrediccionesFantasy: `${process.env.NEXT_PUBLIC_API}/predicciones-fantasy/jornada`,
    GuardarPrediccionesFantasy: `${process.env.NEXT_PUBLIC_API}/predicciones-fantasy/guardar`,
    GetRankingPrediccionesFantasy: `${process.env.NEXT_PUBLIC_API}/predicciones-fantasy/ranking`,
    ObtenerPrediccionesUsuario: `${process.env.NEXT_PUBLIC_API}/predicciones-fantasy/jornada/usuario`,

    // Publicaciones
    GetPublicaciones: `${process.env.NEXT_PUBLIC_API}/publicaciones/paginated`,
    GetPublicacion: (slug) => `${process.env.NEXT_PUBLIC_API}/publicaciones/${slug}`,

    // Noticias por jugadores
    GetNoticiasPorJugadores: `${process.env.NEXT_PUBLIC_API}/noticias/noticias-jugadores`,

    // Comentarios
    GetComentariosBySlug: (slug) => `${process.env.NEXT_PUBLIC_API}/comentarios/${slug}`,
    GetComentariosPaginados: `${process.env.NEXT_PUBLIC_API}/comentarios/listado`,
    CreateComentario: `${process.env.NEXT_PUBLIC_API}/comentarios`,
    UpdateComentario: (id) => `${process.env.NEXT_PUBLIC_API}/comentarios/${id}`,
    DeleteComentario: (id) => `${process.env.NEXT_PUBLIC_API}/comentarios/${id}`,
    ToggleLikeComentario: (id, isLike) =>
        `${process.env.NEXT_PUBLIC_API}/comentarios/${id}/like?isLike=${isLike}`,

    // Apuestas Deportivas
    GET_URL_FeedApuestasDeportivas: `${process.env.NEXT_PUBLIC_API}/apuestas-deportivas/feed`,

    // Posts
    CreatePost: `${process.env.NEXT_PUBLIC_API}/posts`,
    UpdatePost: (id) => `${process.env.NEXT_PUBLIC_API}/posts/${id}`,
    GetPost: (id) => `${process.env.NEXT_PUBLIC_API}/posts/${id}`,
    ListPosts: `${process.env.NEXT_PUBLIC_API}/posts/list`,
    SetPostStatus: (id) => `${process.env.NEXT_PUBLIC_API}/posts/${id}/status`,
    DeletePost: (id, mode = 'soft') => `${process.env.NEXT_PUBLIC_API}/posts/${id}?mode=${mode}`,
};

export default URL_FACTORY;
